import { render, staticRenderFns } from "./WidgetAiPrompt.vue?vue&type=template&id=3d4159f2&scoped=true"
import script from "./WidgetAiPrompt.vue?vue&type=script&setup=true&lang=ts"
export * from "./WidgetAiPrompt.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WidgetAiPrompt.vue?vue&type=style&index=0&id=3d4159f2&prod&scoped=true&lang=css"
import style1 from "./WidgetAiPrompt.vue?vue&type=style&index=1&id=3d4159f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4159f2",
  null
  
)

export default component.exports